import React from 'react';
import {
	TableCell,
	TableRow
} from '@material-ui/core';
export default class ResultsTableHolder extends React.Component {
	render() {
		var standard = this.props.standard;
		const { result = "---" }= this.props;
		var formattedResult = !result.toFixed ? result : this.props.children !== 'TI' ? result.toFixed(2) : result == -1 ? 'N/C' : result.toFixed(1);
		//above line is to format the result to 2 decimal places if it is a number and not the TI result (which is a number to 1 decimal place) 
		//or if it is -1 (which is a special case for TI result)

		var symbol = this.props.symbol;
		if (this.props.symbol === undefined) symbol = '';
		if (this.props.defaultBool) standard = this.props.defaultValue;

		var resultClass = this.props.greater
		? standard <= result ? 'passed' : 'fail'
		: standard >= result ? 'passed' : 'fail';

		if (this.props.hide === true) return null;
		else if (this.props.columnProp === true) {
			if (result === '---' || result === 'Failed') {
				return (
					<TableRow>
						<TableCell>{this.props.children}</TableCell>
						<TableCell>N/A</TableCell>
						<TableCell>{formattedResult}</TableCell>
					</TableRow>
				);
			}
			else return (
				<TableRow>
					<TableCell>{this.props.children}</TableCell>
					<TableCell>N/A</TableCell>
					<TableCell>{formattedResult}{symbol}</TableCell>
				</TableRow>

			);
		}
		else return (
			<TableRow>
				<TableCell>{this.props.children}</TableCell>
				<TableCell>{symbol + ' ' + standard}</TableCell>
				<TableCell className={resultClass} style={resultClass === 'fail' && standard != 'N/A' ? { color: 'red' } : {}}>{formattedResult}</TableCell>
			</TableRow>
		);
	}
}
